import React from 'react'
import { getId } from '../twd'

export default ({field, form, error, label, labelStyle, ...props}) => {
    const id = getId()
    let err = form.errors && form.errors[field.name]
    return (
    <React.Fragment>
    {label && <label htmlFor={id} style={labelStyle}>{label}</label>}

    <div className={(err || error ? ' has-error': '')}>
    <input type="text"
        className="form-control vertical-offset-xxs"
        id={id}
        name={field.name}
        value={field.value}
        {...field}
        {...props}
        {...(err || error ? {"aria-invalid":true} : {})}
        onChange={(e) =>{
            form.setFieldValue(field.name, e.target.value || '')
        }}
        />
    { err && <label className="field-status has-error">{err}</label> }
    </div>

    </React.Fragment>)
}
